import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  JobseekerModerationAttributeEnum,
  RejectModel,
} from '../../shared/models/jobseeker-moderation.model';

@Component({
  selector: 'app-jobseeker-moderation-education',
  templateUrl: './jobseeker-moderation-education.component.html',
  styleUrls: ['./jobseeker-moderation-education.component.less'],
  standalone: false,
})
export class JobseekerModerationEducationComponent {
  @Input() educations: any;
  @Input() isCreate: boolean;
  @Input() isEdited: boolean;
  @Input() changes: any;
  @Output() setDictionary: EventEmitter<RejectModel> =
    new EventEmitter<RejectModel>();
  public jobseekerEnum: any;

  constructor() {
    this.jobseekerEnum = JobseekerModerationAttributeEnum;
  }

  reject(event) {
    this.setDictionary.emit({ key: event.key, value: event.value });
  }
  checkAddedAndModifiedEducations(id: number) {
    return (
      this.changes.jobseekerEducationChanges?.addedEducations?.some(
        (val) => val.jobseekerEducationId === id
      ) ||
      this.changes.jobseekerEducationChanges?.changedEducations?.some(
        (val) => val.jobseekerEducationId === id
      )
    );
  }
}
